import React from 'react'
import PropTypes from 'prop-types'
import { Edit, Delete } from '@material-ui/icons'
import { Button } from 'ui-components/Button'
import { Title } from 'ui-components/Title'
import {
  Container,
  TopPage,
  TopPageOptions,
  Content,
} from './styles'

export default function InfoPage(props) {
  const {
    children,
    renderMenu,
    title,
    subtitle,
    onEdit,
    onDelete,
  } = props

  const renderEditButton = () => (
    <Button
      buttonType="floating"
      size="small"
      onClick={() => onEdit()}
    >
      <Edit />
    </Button>
  )

  const renderDeleteButton = () => (
    <Button
      buttonType="floating"
      size="small"
      onClick={() => onDelete()}
    >
      <Delete />
    </Button>
  )

  return (
    <Container>
      <TopPage>
        <Title
          title={title}
          subtitle={subtitle}
        />
        <TopPageOptions>
          { onDelete ? renderDeleteButton() : null }
          { onEdit ? renderEditButton() : null }
        </TopPageOptions>
      </TopPage>
      <Content>
        { renderMenu() }
        <div>
          { children }
        </div>
      </Content>
    </Container>
  )
}

InfoPage.propTypes = {
  renderMenu: PropTypes.func.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.node,
    PropTypes.array,
  ]).isRequired,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  onEdit: PropTypes.func,
  onDelete: PropTypes.func,
}

InfoPage.defaultProps = {
  title: '',
  subtitle: '',
  onEdit: null,
  onDelete: null,
}
